import { c as _c } from "react/compiler-runtime";
import { Button } from '@repo/design-system/components/ds/button';
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { FlexRow } from '@repo/design-system/components/layout/flex-row';
import { GridSelectItem, Select } from '@repo/design-system/components/ui/select';
import { Type } from '@repo/design-system/components/ui/type';
import { ICONS } from '@repo/types/maps/map-icons';
import { getFontInfoForGlyph, getIconForGlyph, getSubcategoryIconStyle } from '@repo/types/maps/map-utils';
import { useEffect, useMemo, useState } from 'react';
import { getGameFontUrl } from '../../game-map/hooks/fontUtils';
import { loadGameFontIcons } from './game-font-icons';
export interface MapIcon {
  id: string;
  name: string;
  label?: string;
}
export interface MapIconSelectorProps {
  selectedIcon: string;
  onIconChange: (iconId: string) => void;
  label?: string;
  placeholder?: string;
  size?: 'sm' | 'md' | 'lg';
  disabled?: boolean;
  icons?: MapIcon[];
  virtualized?: boolean;
  grid?: boolean;
  gridCols?: number;
  gridItemSize?: number;
  fontId?: string;
}
const mapIcons = Object.entries(ICONS.glyphs).map(([key, value]) => ({
  id: value,
  name: key
}));
const GAME_FONT_RETRY_INITIAL_DELAY_MS = 1_000;
const GAME_FONT_RETRY_MAX_DELAY_MS = 30_000;
function installGameFont(fontId: string): void {
  const fontUrl = getGameFontUrl(fontId);
  let style = document.getElementById('creator-game-icon-font');
  if (!style) {
    style = document.createElement('style');
    style.id = 'creator-game-icon-font';
    document.head.appendChild(style);
  }
  style.textContent = `@font-face {
        font-family: ${JSON.stringify(fontId)};
        src: url(${JSON.stringify(fontUrl)}) format('truetype');
        font-display: block;
    }`;
}
export const MapIconSelector = t0 => {
  const $ = _c(83);
  const {
    selectedIcon,
    onIconChange,
    label: t1,
    placeholder: t2,
    size: t3,
    disabled: t4,
    icons: t5,
    virtualized: t6,
    grid: t7,
    gridCols: t8,
    gridItemSize: t9,
    fontId
  } = t0;
  const label = t1 === undefined ? "Icon:" : t1;
  const placeholder = t2 === undefined ? "Select Icon" : t2;
  const size = t3 === undefined ? "sm" : t3;
  const disabled = t4 === undefined ? false : t4;
  const icons = t5 === undefined ? mapIcons : t5;
  const virtualized = t6 === undefined ? true : t6;
  const grid = t7 === undefined ? true : t7;
  const gridCols = t8 === undefined ? 4 : t8;
  const gridItemSize = t9 === undefined ? 40 : t9;
  let t10;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = [];
    $[0] = t10;
  } else {
    t10 = $[0];
  }
  const [gameFontIcons, setGameFontIcons] = useState(t10);
  let t11;
  let t12;
  if ($[1] !== fontId) {
    t11 = () => {
      let active = true;
      let retryTimer = null;
      setGameFontIcons([]);
      if (!fontId) {
        return () => {
          active = false;
        };
      }
      const activeFontId = fontId;
      async function loadIcons(attempt) {
        try {
          const loadedIcons = await loadGameFontIcons(activeFontId);
          if (!active) {
            return;
          }
          if (loadedIcons.length > 0) {
            installGameFont(activeFontId);
          }
          setGameFontIcons(loadedIcons);
        } catch {
          if (!active) {
            return;
          }
          const retryDelay = Math.min(GAME_FONT_RETRY_INITIAL_DELAY_MS * 2 ** attempt, GAME_FONT_RETRY_MAX_DELAY_MS);
          retryTimer = setTimeout(() => {
            retryTimer = null;
            loadIcons(attempt + 1);
          }, retryDelay);
        }
      }
      loadIcons(0);
      return () => {
        active = false;
        if (retryTimer) {
          clearTimeout(retryTimer);
        }
      };
    };
    t12 = [fontId];
    $[1] = fontId;
    $[2] = t11;
    $[3] = t12;
  } else {
    t11 = $[2];
    t12 = $[3];
  }
  useEffect(t11, t12);
  let t13;
  if ($[4] !== gameFontIcons || $[5] !== icons) {
    t13 = [...gameFontIcons, ...icons];
    $[4] = gameFontIcons;
    $[5] = icons;
    $[6] = t13;
  } else {
    t13 = $[6];
  }
  const availableIcons = t13;
  let T0;
  let T1;
  let T2;
  let T3;
  let T4;
  let selectedIconData;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t20;
  let t21;
  let t22;
  let t23;
  let t24;
  let t25;
  let t26;
  let t27;
  let t28;
  let t29;
  let t30;
  let t31;
  let t32;
  if ($[7] !== availableIcons || $[8] !== disabled || $[9] !== grid || $[10] !== gridCols || $[11] !== gridItemSize || $[12] !== label || $[13] !== selectedIcon || $[14] !== size || $[15] !== virtualized) {
    selectedIconData = availableIcons.find(icon => icon.name === selectedIcon);
    T4 = FlexColumn;
    t32 = "4";
    T3 = Select;
    t23 = label;
    t24 = true;
    t25 = virtualized;
    t26 = grid;
    t27 = gridCols;
    t28 = gridItemSize;
    t29 = 400;
    t30 = 40;
    t31 = "lg";
    T2 = Button;
    t19 = "secondary";
    t20 = size;
    t21 = true;
    t22 = disabled;
    T1 = FlexRow;
    t16 = "center";
    t17 = "center";
    t18 = "12";
    T0 = Type;
    t14 = "body-m";
    t15 = selectedIconData?.name ? getSubcategoryIconStyle(getFontInfoForGlyph(selectedIconData.name).fontName) : undefined;
    $[7] = availableIcons;
    $[8] = disabled;
    $[9] = grid;
    $[10] = gridCols;
    $[11] = gridItemSize;
    $[12] = label;
    $[13] = selectedIcon;
    $[14] = size;
    $[15] = virtualized;
    $[16] = T0;
    $[17] = T1;
    $[18] = T2;
    $[19] = T3;
    $[20] = T4;
    $[21] = selectedIconData;
    $[22] = t14;
    $[23] = t15;
    $[24] = t16;
    $[25] = t17;
    $[26] = t18;
    $[27] = t19;
    $[28] = t20;
    $[29] = t21;
    $[30] = t22;
    $[31] = t23;
    $[32] = t24;
    $[33] = t25;
    $[34] = t26;
    $[35] = t27;
    $[36] = t28;
    $[37] = t29;
    $[38] = t30;
    $[39] = t31;
    $[40] = t32;
  } else {
    T0 = $[16];
    T1 = $[17];
    T2 = $[18];
    T3 = $[19];
    T4 = $[20];
    selectedIconData = $[21];
    t14 = $[22];
    t15 = $[23];
    t16 = $[24];
    t17 = $[25];
    t18 = $[26];
    t19 = $[27];
    t20 = $[28];
    t21 = $[29];
    t22 = $[30];
    t23 = $[31];
    t24 = $[32];
    t25 = $[33];
    t26 = $[34];
    t27 = $[35];
    t28 = $[36];
    t29 = $[37];
    t30 = $[38];
    t31 = $[39];
    t32 = $[40];
  }
  let t33;
  if ($[41] !== selectedIconData) {
    t33 = selectedIconData?.id && <>{selectedIconData.id}</>;
    $[41] = selectedIconData;
    $[42] = t33;
  } else {
    t33 = $[42];
  }
  let t34;
  if ($[43] !== T0 || $[44] !== t14 || $[45] !== t15 || $[46] !== t33) {
    t34 = <T0 variant={t14} style={t15}>{t33}</T0>;
    $[43] = T0;
    $[44] = t14;
    $[45] = t15;
    $[46] = t33;
    $[47] = t34;
  } else {
    t34 = $[47];
  }
  const t35 = selectedIconData?.label || selectedIconData?.name || placeholder;
  let t36;
  if ($[48] !== T1 || $[49] !== t16 || $[50] !== t17 || $[51] !== t18 || $[52] !== t34 || $[53] !== t35) {
    t36 = <T1 align={t16} justify={t17} gap={t18}>{t34}{t35}</T1>;
    $[48] = T1;
    $[49] = t16;
    $[50] = t17;
    $[51] = t18;
    $[52] = t34;
    $[53] = t35;
    $[54] = t36;
  } else {
    t36 = $[54];
  }
  let t37;
  if ($[55] !== T2 || $[56] !== t19 || $[57] !== t20 || $[58] !== t21 || $[59] !== t22 || $[60] !== t36) {
    t37 = <T2 color={t19} size={t20} fullWidth={t21} disabled={t22}>{t36}</T2>;
    $[55] = T2;
    $[56] = t19;
    $[57] = t20;
    $[58] = t21;
    $[59] = t22;
    $[60] = t36;
    $[61] = t37;
  } else {
    t37 = $[61];
  }
  let t38;
  if ($[62] !== availableIcons || $[63] !== gridItemSize) {
    t38 = availableIcons.map(icon_0 => <GridSelectItem key={icon_0.name} item={{
      label: icon_0.label || icon_0.name,
      value: icon_0.name
    }} searchText={icon_0.label || icon_0.name} size={gridItemSize}><Type variant="header-m" style={{
        ...getSubcategoryIconStyle(getFontInfoForGlyph(icon_0.name).fontName),
        fontSize: "24px"
      }}>{getIconForGlyph(icon_0.name)}</Type></GridSelectItem>);
    $[62] = availableIcons;
    $[63] = gridItemSize;
    $[64] = t38;
  } else {
    t38 = $[64];
  }
  let t39;
  if ($[65] !== T3 || $[66] !== onIconChange || $[67] !== t23 || $[68] !== t24 || $[69] !== t25 || $[70] !== t26 || $[71] !== t27 || $[72] !== t28 || $[73] !== t29 || $[74] !== t30 || $[75] !== t31 || $[76] !== t37 || $[77] !== t38) {
    t39 = <T3 label={t23} searchable={t24} virtualized={t25} grid={t26} gridCols={t27} gridItemSize={t28} maxHeight={t29} itemHeight={t30} size={t31} trigger={t37} onValueChange={onIconChange}>{t38}</T3>;
    $[65] = T3;
    $[66] = onIconChange;
    $[67] = t23;
    $[68] = t24;
    $[69] = t25;
    $[70] = t26;
    $[71] = t27;
    $[72] = t28;
    $[73] = t29;
    $[74] = t30;
    $[75] = t31;
    $[76] = t37;
    $[77] = t38;
    $[78] = t39;
  } else {
    t39 = $[78];
  }
  let t40;
  if ($[79] !== T4 || $[80] !== t32 || $[81] !== t39) {
    t40 = <T4 gap={t32}>{t39}</T4>;
    $[79] = T4;
    $[80] = t32;
    $[81] = t39;
    $[82] = t40;
  } else {
    t40 = $[82];
  }
  return t40;
};